<template>
  <transition name="fade">
    <div v-if="isExploring" class="modal-background" @click="$emit('exitExplore')"></div>
  </transition>
</template>

<script>
export default {
  props: ['isExploring']
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .fade-enter-active {
    transition: opacity 0.25s
  }

  .fade-leave-active {
    transition: opacity 1s
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
  }

  .modal-background {
    position: fixed;
    top: $navbar-height;
    bottom: 0;
    z-index: 13;
  }
</style>
